import { render } from "./ItemSort.vue?vue&type=template&id=53f48882&scoped=true"
import script from "./ItemSort.vue?vue&type=script&lang=js"
export * from "./ItemSort.vue?vue&type=script&lang=js"

import "./ItemSort.vue?vue&type=style&index=0&id=53f48882&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f48882"]])

export default __exports__